/* eslint-disable import/no-anonymous-default-export */
export default {
    // API_ENDPOINT: 'http://localhost:7070/api',
    API_ENDPOINT: 'https://growing-up-server.herokuapp.com/api',
    TOKEN_KEY: 'growing-up-client-auth-token'
};
